import { Business, Individual } from '~/types';

export type ProfileResource = 'individuals' | 'businesses';

export interface RecordTitleProps {
  record: Individual | Business;
  resource: ProfileResource;
  avatarSource: string;
  headline: any;
  subtitle: any;
  translate: (key: string) => string;
  hasPathnameProfile: boolean;
}

export const translatePrefix = `components.RecordTitle`;

export const l = (key: string): string => `${translatePrefix}.${key}`;
